<template>
    <b-row>
        <b-col sm="12">
            <b-card>
                <div slot="header">
                    <span class="card-title wise-card-title">회원 정보</span>
                </div>
                <b-row class="pt-2">
                    <b-col sm="12">
                        <table class="table table-bordered oddBackground">
                            <tbody>
                                <tr>
                                    <td style="width:15%">아이디</td>
                                    <td class="tl" style="width:35%;">{{ userDetailInfo.user_id }}</td>
                                    <td style="width:15%">이름</td>
                                    <td class="tl" style="width:35%;">{{ userDetailInfo.name }}</td>
                                </tr>
                                <tr>
                                    <td>회원구분</td>
                                    <td class="tl">{{ userDetailInfo.authority_name }}회원</td>
                                    <td>휴대폰번호</td>
                                    <td class="tl">
                                        <span>
                                            {{ userDetailInfo.mobile | phoneNumberRegx }}
                                        </span>
                                        <span class="badge badge-danger">
                                            {{ userDetailInfo.mobile_cert_yn === "Y" ? "인증완료" : "미인증" }}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>생년월일</td>
                                    <td class="tl">{{ userDetailInfo.birthday }}</td>
                                    <td>가입일</td>
                                    <td class="tl">{{ userDetailInfo.reg_date }}</td>
                                </tr>
                                <tr>
                                    <td>마케팅 수신동의 여부</td>
                                    <td class="tl">{{ userDetailInfo.letter_yn }}</td>
                                    <td>휴면여부</td>
                                    <td class="tl">{{ userDetailInfo.user_status_name }}</td>
                                </tr>
                                <tr>
                                    <td>회사(기관)정보</td>
                                    <td class="tl">{{ userDetailInfo.industry_name }}</td>
                                    <td>회사(기관)명</td>
                                    <td class="tl">{{ userDetailInfo.company_name }}</td>
                                </tr>
                                <tr>
                                    <td>부서명</td>
                                    <td class="tl">{{ userDetailInfo.dept_name }}</td>
                                    <td>직무</td>
                                    <td class="tl">{{ userDetailInfo.job_position }}</td>
                                </tr>
                                <tr>
                                    <td>직급</td>
                                    <td class="tl" colspan="3">{{ userDetailInfo.job_level }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <hr />
                <b-row class="pt-2">
                    <b-col sm="12">
                        <table class="table table-bordered oddBackground">
                            <tbody>
                                <tr>
                                    <td style="width:15%; vertical-align: middle;">관심카테고리</td>
                                    <td style="width:85%; text-align: left;">
                                        <template v-for="code in interestCodes">
                                            <button type="button" class="btn btn-outline-primary"
                                                style="margin-right: 1%; cursor: default;" :id="code.item_code">
                                                {{ code.item_name }}
                                            </button>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
export default {
    name: "userDetail",
    props: {
        userId: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            userDetailInfo: {},
            interestCodes: [],
        }
    },
    mounted() {

    },
    watch: {
        userId: function (value, oldValue) {
            // 통신 부분
            this.selectInterestCode();
            this.selectReportUser();
        },
        userDetailInfo: function (value, oldValue) {
            // console.log('watch > ', value, oldValue);
            this.setCategory(value)
        }
    },
    methods: {
        // 관심 카테고리 목록
        selectInterestCode() {
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/itemCodeList?access_token=' + token + '&parentCode=INTEREST_FIELD_CODE')
                .then((result) => {
                    // console.log(result.data);
                    this.interestCodes = result.data;
                })
        },
        // 회원 정보
        selectReportUser() {
            // console.log('user_id >> ', this.userId);
            var token = sessionStorage.getItem("myToken");
            this.$http.get('/api/select/reportUser?access_token=' + token + '&user_id=' + this.userId)
                .then((result) => {
                    this.userDetailInfo = result.data;
                })
        },
        // 관심카테고리 체크
        setCategory(value){
            const { interestFieldCodeList } = value;
            // console.log('>>>>', interestFieldCodeList.length);
            interestFieldCodeList.forEach(item => {
                // console.log('>>>>', item.interest_field_code);
                document.querySelector('#' + item.interest_field_code).classList.remove("btn-outline-primary");
                document.querySelector('#' + item.interest_field_code).classList.add("btn-primary");
            });
        }
    },
}
</script>
<style lang="css" scoped>
.oddBackground td:nth-child(odd) {
  background:#dcdcdc;
  font-weight: 600;
  text-align: center;
}
.theader{
  background:#dcdcdc;
  font-weight: 600;
}

.tl {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/user/userDetail/component/UserDetail.vue